const accrualBasisOptions = [
  { key: "30/360", value: "30/360", text: "30/360" },
  { key: "30/365", value: "30/365", text: "30/365" },
  { key: "Actual/Actual", value: "Actual/Actual", text: "Actual/Actual" },
  { key: "Actual/360", value: "Actual/360", text: "Actual/360" },
  { key: "Actual/365", value: "Actual/365", text: "Actual/365" }
];

export default accrualBasisOptions;
